// case
export default {
    getPageHistory(state) {
        return state.pageHistory;
    },

    getCurrentPageIndex(state) {
        return state.currentPageIndex;
    },

    getCurrentPagePhase(state) {
        return state.currentPagePhase;
    }
}
